import { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import UserService from "../../Services/UserService";
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as Save } from '../../Assets/img/Edit-icon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

/**
 * Renders reset password pop up, letting an administrator set a new password for another user
 * without knowing the current one. The password set here is temporary -- the target user is
 * asked to replace it with their own the next time they sign in.
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 * @param {Object} props.user The user row, providing props.user.username
 */
function ResetPassword(props) {

    //#region States

    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    //#endregion

    //#region Refs

    const newPasswordInputRef = useRef();
    const confirmPasswordInputRef = useRef();

    //#endregion

    //#region Reset password

    /**
    * Calls user service to reset the selected user's password
    * @param {Event} event User action (on submitting form)
    */
    function resetHandler(event) {
        event.preventDefault();

        const enteredNewPassword = newPasswordInputRef.current.value;
        const enteredConfirmPassword = confirmPasswordInputRef.current.value;

        if (enteredNewPassword !== enteredConfirmPassword) {
            setError("New Password and Confirm New Password not matching");
            setMessagePopup(true);
            return;
        }

        var resetUserPasswordDTO = {
            Request: {
                Username: props.user.username,
                NewPassword: enteredNewPassword,
            }
        };

        UserService.resetUserPassword(resetUserPasswordDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors?.[0]?.message || "Failed to reset the password.");
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage(response.response);
                }
            })
            .catch((err) => {
                setError(err.response?.data?.errors?.[0]?.message || "Failed to reset the password.");
                setMessagePopup(true);
            });
    }

    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Reset Password</strong>
                </ModalTitle>
            </ModalHeader>

            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={resetHandler}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="Username" className="label">Username</label>
                            <input
                                className="InputField"
                                type="text"
                                value={props.user.username}
                                readOnly
                                disabled
                            />
                        </div>
                        <br />
                        {/* autoComplete new-password: the admin is setting someone else's password,
                            so the browser must not autofill their own saved one. */}
                        <div>
                            <label for="NewPassword" className="label">New Password</label>
                            <input
                                className="InputField"
                                type="password"
                                placeholder="-Text-"
                                ref={newPasswordInputRef}
                                autoComplete="new-password"
                                required
                            />
                        </div>
                        <br />
                        <div>
                            <label for="ConfirmPassword" className="label">Confirm New Password</label>
                            <input
                                className="InputField"
                                type="password"
                                placeholder="-Text-"
                                ref={confirmPasswordInputRef}
                                autoComplete="new-password"
                                required
                            />
                        </div>
                        <br />
                        <div className="label" style={{ opacity: 0.7 }}>
                            The user will be asked to set their own password the next time they sign in.
                        </div>
                    </div>
                    <div>
                        <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                            <div>
                                <button type="reset" className="secondary-button" onClick={() => {
                                    setError("");
                                    setMessagePopup(false);
                                }}>
                                    <span className="secondary-button-icon"><ResetIcon /></span>
                                    <span className="secondary-button-text">Reset</span>
                                </button>
                                &nbsp;
                                <button type="submit" className="primary-button ">
                                    <span className="primary-button-icon"><Save /></span>
                                    <span className="primary-button-text">Reset Password</span>
                                </button>
                            </div>
                        </ModalFooter>
                    </div>
                </form>
            </Modal.Body>
        </Modal >
    );
}

export default ResetPassword;
